(() => {
  const escapeSelector = (value) => {
    if (window.CSS?.escape) return window.CSS.escape(value);
    return value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  };

  const prepareMenu = (source) => {
    if (source.dataset.p3dMenuPrepared === 'true') return;

    const tabs = source.querySelector('tabs-element');
    const categorySources = source.querySelector('.p3d-floating-menu__category-sources');
    const panels = source.querySelector('.p3d-floating-menu__panels');
    if (!tabs || !categorySources || !panels) return;

    const entries = Array.from(categorySources.querySelectorAll(':scope > [data-p3d-category-source]'));
    entries.forEach((entry, index) => {
      const button = entry.querySelector(':scope > [data-p3d-category-button]');
      const panel = entry.querySelector(':scope > [data-p3d-category-panel]');

      if (button) tabs.insertBefore(button, categorySources);
      if (panel) {
        panel.hidden = index !== 0;
        panels.appendChild(panel);
      }
    });

    const buttons = Array.from(tabs.querySelectorAll('button[role="tab"]'));
    buttons.forEach((button, index) => {
      button.classList.toggle('button--primary', index === 0);
      button.classList.toggle('button--secondary', index !== 0);
      button.disabled = index === 0;
    });
    tabs.setAttribute('selected-index', '0');
    source.dataset.p3dMenuPrepared = 'true';
  };

  const upgradeNavigationItem = (section, source) => {
    const menuTitle = source.dataset.p3dMenuTitle;
    if (!menuTitle) return null;

    const navItem = section.querySelector(`[data-header-nav-title="${escapeSelector(menuTitle)}"]`);
    if (!navItem) return null;

    const existingSlot = navItem.querySelector('[data-p3d-menu-slot]');
    if (existingSlot) return existingSlot;

    const currentMenuItem = navItem.querySelector(':scope > a.menu__item, :scope > details > summary .menu__item');
    if (!currentMenuItem) return null;

    const template = document.createElement('template');
    template.innerHTML = '<details is="details-mega"><summary><magnet-element></magnet-element></summary><div class="mega-menu absolute top-0 left-0 w-full max-w-full overflow-hidden pointer-events-none"><div class="mega-menu__container p3d-floating-menu__shell invisible"></div></div></details>';
    const details = template.content.firstElementChild;
    details.setAttribute('trigger', navItem.dataset.headerNavTrigger || 'hover');
    details.setAttribute('level', 'top');

    const summary = details.querySelector('summary');
    summary.dataset.link = navItem.dataset.headerNavUrl || '';
    summary.className = `z-2 relative${navItem.dataset.headerNavActive === 'block' ? ' rounded-full' : ''}`;
    summary.setAttribute('aria-haspopup', 'true');
    summary.setAttribute('aria-expanded', 'false');
    summary.setAttribute('aria-label', navItem.dataset.headerNavLabel || '');

    const magnet = details.querySelector('magnet-element');
    magnet.className = currentMenuItem.className;
    magnet.innerHTML = currentMenuItem.innerHTML;
    if (navItem.dataset.headerNavActive === 'block') magnet.dataset.magnet = '0';

    const slot = details.querySelector('.p3d-floating-menu__shell');
    slot.dataset.p3dMenuSlot = source.dataset.p3dMenuSource;
    navItem.replaceChildren(details);
    return slot;
  };

  const mountMenus = (root = document) => {
    const stagingAreas = [];
    if (root.matches?.('[data-p3d-menu-staging]')) stagingAreas.push(root);
    root.querySelectorAll?.('[data-p3d-menu-staging]').forEach((area) => stagingAreas.push(area));

    stagingAreas.forEach((staging) => {
      const section = staging.closest('[id^="shopify-section-"]') || document;
      staging.querySelectorAll('[data-p3d-menu-source]').forEach((source) => {
        const blockId = source.dataset.p3dMenuSource;
        const slot = section.querySelector(`[data-p3d-menu-slot="${escapeSelector(blockId)}"]`) || upgradeNavigationItem(section, source);
        if (!slot) return;

        prepareMenu(source);
        slot.replaceChildren(source);
      });
    });
  };

  const selectEditedCategory = (event) => {
    const source = event.target.closest?.('[data-p3d-menu-source]');
    if (!source) return;

    const details = source.closest('details');
    if (details) details.open = true;

    const category = event.target.closest?.('[data-p3d-category-source], [data-p3d-category-panel]');
    if (!category) return;
    const categoryId = category.dataset.p3dCategorySource || category.dataset.p3dCategoryPanel;

    const tabs = source.querySelector('tabs-element');
    const buttons = Array.from(tabs?.querySelectorAll('button[role="tab"]') || []);
    const index = buttons.findIndex((button) => button.dataset.p3dCategoryButton === categoryId);
    if (index >= 0) tabs.selectedIndex = index;
  };

  mountMenus();
  document.addEventListener('shopify:section:load', (event) => mountMenus(event.target));
  document.addEventListener('shopify:block:select', selectEditedCategory);
})();
